// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Jx2wk","topBuyerImage":"style_topBuyerImage__YAcms","scrollContainer":"style_scrollContainer__ut3RH"};